<template>
    <div class="relative">
        <div class="flex">
            <calendar-day
                v-for="(day, index) in weekDays"
                :key="`${index}-${weekIndex}`"
                :day="day"
                :week-index="weekIndex"
                :start-week-day="startWeekDay"
                @update-holiday-week="handleUpdateHolidayWeek"
                @click.native="scrollToDeliveryCard"
                :deliveries="setThisWeeksDelivery">
            </calendar-day>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isUsingMobileDevice } from '@/helpers/MobileDetectionHelpers';
import CalendarDay from '@/components/partials/account/my-delivery-schedule/calendar/CalendarDay';
import {
    includesDayInCurrentWeek,
    includesDayWithNoIdInCurrentWeek,
} from '@/helpers/DateHelpers';

export default {
    name: 'CalendarWeek',
    data() {
        return {
            updatedHolidayWeek: null,
        };
    },
    props: {
        startWeekDay: {
            required: true,
            type: Object,
        },
        weekIndex: {
            required: true,
            type: String,
        },
    },
    mounted() {
        this.updatedHolidayWeek = this.isWeekWithLabel();
    },
    components: {
        CalendarDay,
    },
    computed: {
        ...mapGetters({
            deliveries: 'scheduledOrder/getDeliveries',
            deliveryDayName: 'scheduledOrder/getDeliveryDayName',
            holidays: 'scheduledOrder/getHolidays',
            optInDeliveryDays: 'scheduledOrder/getOptInDeliveryDays',
            undeliverableDays: 'scheduledOrder/getUndeliverableDays',
        }),
        dayWithLabel() {
            return this.isWednesdayOrBefore ? this.startWeekDay.clone().add(1, 'week') : this.startWeekDay.clone();
        },
        deliveryWeekday() {
            return this.deliveryDayName ? this.$moment().day(this.deliveryDayName).isoWeekday() : 0;
        },
        isHolidayWeek() {
            return this.updatedHolidayWeek === null ? this.isWeekWithLabel() : this.updatedHolidayWeek;
        },
        isWednesdayOrBefore() {
            return this.deliveryWeekday <= 3;
        },
        weekDays() {
            return Array.from(Array(7).keys()).map(value => this.startWeekDay.clone().add(value, 'days'));
        },
        setThisWeeksDelivery() {
            const start = this.startWeekDay.clone().subtract(1, 'days').format('YYYY-MM-DD');
            const end = this.startWeekDay.clone().add(6, 'days').format('YYYY-MM-DD');

            return this.deliveries.filter(delivery => this.$moment(delivery.datetime).isBetween(start, end));
        },
    },
    methods: {
        isWeekWithLabel() {
            const isHolidayWeek = includesDayInCurrentWeek(this.dayWithLabel, this.holidays);
            const isOptOutWeek = includesDayWithNoIdInCurrentWeek(this.dayWithLabel, this.optInDeliveryDays);
            const isUndeliverableWeek = includesDayInCurrentWeek(this.dayWithLabel, this.undeliverableDays);

            return isHolidayWeek || isOptOutWeek || isUndeliverableWeek;
        },
        handleUpdateHolidayWeek(isHoliday) {
            this.updatedHolidayWeek = isHoliday;
        },
        scrollToDeliveryCard() {
            const orientation = window.orientation ? 'landscape' : 'portrait';
            if (isUsingMobileDevice()) {
                this.$parent.$parent.$scrollTo(`#${orientation}-scroll-hook`);
            }
        },
    },
};
</script>
